<template>
  <!-- ebook dialog -->
  <v-dialog
    v-model="isOpen"
    width="550px"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-book-open-page-variant</v-icon
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertEbook.addEditEbook'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="checkToSave" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertEbook.close'
            )
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="beforeValidate">
          <!-- <v-row justify="center"> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertEbook.ebookName'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                :rules="nameRules"
                clearable
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertEbook.ebookName'
                  )
                "
                v-model="title"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertEbook.detail'
                  )
                }}
              </p>
              <v-textarea
                v-model="description"
                :label="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertEbook.detail'
                  )
                "
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertEbook.pleaseFillDetail'
                  )
                "
                full-width
                outlined
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <p class="title mb-0">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertEbook.perMissionDownload'
                  )
                }}

                <span class="red--text">*</span>
              </p>
              <div class="d-flex align-center">
                <v-radio-group
                  v-model="canDownload"
                  mandatory
                  row
                  hide-details="auto"
                >
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertEbook.noDownload'
                      )
                    "
                    :value="false"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertEbook.canDownload'
                      )
                    "
                    :value="true"
                  ></v-radio>
                </v-radio-group>
              </div>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertEbook.ebookFile'
                  )
                }}
                <span class="red--text">*</span>
                <span class="subtitle-1">{{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertEbook.ebookFileInstruction'
                  )
                }}</span>
              </p>
              <v-file-input
                :rules="fileRules"
                v-model="ebookFile"
                counter
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertEbook.chooseFile'
                  )
                "
                @change="onFileChange"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
                accept=".pdf"
                @click:clear="clearPreview"
              >
                <template v-slot:selection="{ index, text }">
                  <p class="mb-0">{{ text }}</p>
                  <!-- <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>{{ text }}</v-chip> -->

                  <span
                    v-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                    >+{{ files.length - 2 }}
                    {{
                      this.$vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertEbook.files'
                      )
                    }}</span
                  >
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="examplePDF">
              <!-- <label class="title">{{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertEbook.sample'
                )
              }}</label>
              <br /> -->
              <div v-if="!urlPDF" v-show="urlPDF">
                <!-- {{ pdfCurrentPage }} / {{ pdfCountPage }} -->
                <pdf
                  :src="urlPDF"
                  @num-pages="pdfCountPage = $event"
                  @page-loaded="pdfCurrentPage = $event"
                ></pdf>
              </div>
              <iframe class="iframePDF" :src="urlPDF"></iframe>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="checkToSave"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.cancel'
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          @click="beforeValidate"
          :disabled="!valid"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.save'
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
          )
        }}</v-card-title>
        <v-card-text>{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
          )
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeLectureDialog"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.exit'
                )
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import {
  insertLecture,
  updateLecture,
  insertBook,
  updateBook,
} from '@/service/course/course.js';
import { headersWithTokenForImage, domain } from '@/service/configApi';
import { getPrivatePdf } from '@/service/upload/upload.js';
import axios from 'axios';
import pdf from 'vue-pdf';
import { EventBus } from '../../../event-bus';
export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reload: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
    closeLectureDialog: {
      type: Function,
    },
  },
  data() {
    return {
      numPages: undefined,
      pdfCurrentPage: 0,
      pdfCountPage: 0,
      valid: true,
      title: '',
      description: '',
      urlPDF: '',

      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertEbook.pleaseFillName'
          ),
      ],
      successUpload: true,
      pdfUploadId: '',
      ebookFile: null,

      // Edit
      oldFileId: '',
      oldFileUrl: '',
      oldBook: '',

      //check to save
      oldValue: [],
      warnningToSaveDialog: false,
      canDownload: false,
    };
  },
  computed: {
    fileRules() {
      const rules = [];

      if (this.lectureId === undefined) {
        const rule = (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertEbook.chooseFile'
          );

        rules.push(rule);
      }

      return rules;
    },
  },
  watch: {
    // whenever question changes, this function will run
    // lectureId: async function(newValue, oldValue) {
    //   let filterLecture = this.lectures.filter(
    //     lecture => lecture._id === newValue
    //   )[0];
    //   this.title = filterLecture.title;
    //   this.description = filterLecture.description;
    //   let resultLink = await getPrivatePdf(filterLecture.books[0]._id);
    //   this.urlPDF = resultLink;
    //   this.oldFileId = filterLecture.books[0]._id;
    //   this.oldFileUrl = resultLink;
    //   this.successUpload = true;
    // },
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.lectureId) {
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          this.title = filterLecture.title;
          this.description = filterLecture.description;
          this.oldValue = filterLecture;
          this.canDownload = filterLecture.isDownload;
          // let resultLink = await getPrivatePdf(filterLecture.books[0]._id);
          // this.urlPDF = resultLink;
          // this.oldFileId = filterLecture.books[0]._id;
          // this.oldFileUrl = resultLink;
          this.ebookFile = null;
          // this.successUpload = true;

          let resultLink = await getPrivatePdf(filterLecture.books[0].pdf);
          this.urlPDF = resultLink;
          this.oldFileId = filterLecture.books[0].pdf;
          this.oldFileUrl = resultLink;
          this.oldBook = filterLecture.books[0];
          this.successUpload = true;
        } else {
          this.title = '';
          this.description = '';
          this.urlPDF = '';
          this.successUpload = true;
          this.pdfUploadId = '';
          this.ebookFile = null;
          // Edit
          this.oldFileId = '';
          this.oldFileUrl = '';
          this.canDownload = false;
          if (this.$refs.form) {
            this.$refs.form.reset();
          }
        }
      }
    },
    // lectureId: async function(newValue, oldValue) {
    //   let filterLecture = this.lectures.filter(
    //     lecture => lecture._id === newValue
    //   )[0];
    //   this.title = filterLecture.title;
    //   this.description = filterLecture.description;
    //   let resultLink = await getPrivatePdf(filterLecture.books[0].pdf);
    //   this.urlPDF = resultLink;
    //   this.oldFileId = filterLecture.books[0].pdf;
    //   this.oldFileUrl = resultLink;
    //   this.oldBook = filterLecture.books[0];
    //   this.successUpload = true;
    // }
  },
  methods: {
    async beforeValidate() {
      if (this.ebookFile != null) {
        this.uploadFile(this.ebookFile);
      } else {
        this.validate();
      }
    },
    async validate() {
      if (this.$refs.form.validate()) {
        if (!this.lectureId) {
          let book = await insertBook({
            title: this.title,
            year: 2019,
            numBook: 1,
            publisher: 'Deknerd',
            refer: 'deknerd-01',
            isbn: '18748390483948',
            pdf: [this.pdfUploadId],
          });

          await insertLecture({
            id: this.sectionId,
            title: this.title,
            description: this.description,
            type: 'BOOK',
            books: [book._id],
            isDownload: this.canDownload,
          });

          // let newLectures = this.lectures.map(lecture => lecture._id);
          // newLectures.push(result._id);

          this.reload();
          this.closeDialog();
          EventBus.$emit('creditPoint.show');
        } else {
          let currentLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          await updateBook({
            ...this.oldBook,
            id: this.oldBook._id,
            pdf: this.pdfUploadId ? [this.pdfUploadId] : [this.oldFileId],
          });

          await updateLecture({
            ...currentLecture,
            id: this.lectureId,
            title: this.title,
            description: this.description,
            type: 'BOOK',
            books: [this.oldBook._id],
            isDownload: this.canDownload,
          });
        }
        this.closeLectureDialog();
      }
    },
    async onFileChange(file) {
      if (file === undefined) {
        this.ebookFile = file;
        this.urlPDF = '';
        if (this.lectureId) {
          this.urlPDF = this.oldFileUrl;
        }
        return;
      }

      this.ebookFile = file;
      this.urlPDF = await URL.createObjectURL(file);
      var loadingTask = await pdf.createLoadingTask(this.urlPDF);
      await loadingTask.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    },
    async uploadFile(file) {
      this.successUpload = false;
      let formData = new FormData();
      /*
        Add the form data we need to submit
      */
      formData.append('fileupload', file);
      formData.append('title', file.name);
      // formData.append("allpage", this.numPages);
      // this.numPages, แก้เป็นส่ง 0 เพียงแค่ชั่วคราวเท่านั้น
      formData.append('allpage', 0);
      /*
        Make the request to the POST /single-file URL
      */
      axios
        .post(
          `${domain}/uploadfile/private/pdf/course` + '?allpage=' + 0,
          // this.numPages, แก้เป็นส่ง 0 เพียงแค่ชั่วคราวเท่านั้น
          formData,
          {
            headers: {
              ...headersWithTokenForImage(),
            },
          }
        )
        .then(
          async function (response) {
            this.pdfUploadId = response.data.result;
            let resultLink = await getPrivatePdf(this.pdfUploadId);
            this.urlPDF = resultLink;

            this.validate();
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);

          let msg = 'Can not upload e-book';
          if (e.response != null && e.response.data != null) {
            msg = e.response.data.message;
          }

          EventBus.$emit('snackbar', {
            text: msg,
            dark: true,
            centered: true,
            color: 'error',
          });
        });
    },
    checkToSave() {
      if (this.lectureId) {
        this.title !== this.oldValue.title ||
        this.description !== this.oldValue.description ||
        this.ebookFile
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      } else {
        this.title || this.description || this.ebookFile
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      }
    },
    clearPreview() {
      this.urlPDF = '';
    },
  },
  beforeMount() {},
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.textField {
  width: 100%;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 80%;
  min-height: 570px;
  /* height: 300px; */
  /* overflow: hidden; */
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
</style>
